// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StepBackwardOutlinedSvg from "@fishx/icons-svg/es/asn/StepBackwardOutlined";
import FishxIcon from '../components/FishxIcon';

var StepBackwardOutlined = function StepBackwardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: StepBackwardOutlinedSvg
  }));
};

StepBackwardOutlined.displayName = 'StepBackwardOutlined';
export default React.forwardRef(StepBackwardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/StepBackwardOutlined.js
// module id = 4187
// module chunks = 0